import * as Yup from "yup"

/**
 * Order fields validation
 *
 * @returns {Yup}
 */
export const orderCreateValidation = ({
  ADDITIONAL_INFORMATION_ONE_MSG = "The maximum length is 78 characters",
  ADDITIONAL_INFORMATION_TWO_MSG = "The maximum length is 78 characters",
  ADDITIONAL_INFORMATION_THREE_MSG = "The maximum length is 78 characters",
  DOCUMENT_TYPE_MSG = "This field is required",
  INFOMAIL_MSG = "This field is required",
  COLLECTIVE_INVOICE_TYPE_MSG = "This field is required",
  SHIPPING_METHOD_NAME_MSG = "This field is required",
  BRANCH_ID_MSG = "The maximum length is 3 characters",
  ORDER_TEXT_MSG = "The maximum length is 20 characters",
  ORDER_NUMBER_MSG = "The maximum length is 15 characters",
  ORDER_TEXT_REQUIRED = false,
  ORDER_TEXT_REQUIRED_MSG = "This field is required",
  DISPLAY_RECOMMENDED_STALES_PRICE_MSG = "This field is required",
  PRINT_OFFER_MSG = "This field is required",
  ADM_NUMBER_MSG = "The length has to be 3 characters",
  ADM_NUMBER_REQUIRED_MSG = "This field is required",
  VALID_TILL_REQUIRED_MSG = "Valid till is required",
  validTillRequired,
  costUnitRequired,
  COST_UNIT_MSG = "The maximum length is 20 characters",
  COST_UNIT_REQUIRED_MSG = "This field is required",
  emailSubjectRequired = false,
  EMAIL_SUBJECT_MSG = "The maximum length is 200 characters",
  EMAIL_SUBJECT_REQUIRED_MSG = "This field is required",
} = {}) => {
  return Yup.object({
    additionalInformationOne: Yup.string().max(78, ADDITIONAL_INFORMATION_ONE_MSG),
    additionalInformationTwo: Yup.string().max(78, ADDITIONAL_INFORMATION_TWO_MSG),
    additionalInformationThree: Yup.string().max(78, ADDITIONAL_INFORMATION_THREE_MSG),
    documentType: Yup.string()
      .oneOf(["offer", "cashSale", "order", "reservation", "return"])
      .required(DOCUMENT_TYPE_MSG),
    sendInfoMail: Yup.string().oneOf(["false", "true"]).required(INFOMAIL_MSG),
    displayRecommendedSalesPrice: Yup.string().oneOf(["false", "true"]).required(DISPLAY_RECOMMENDED_STALES_PRICE_MSG),
    printOffer: Yup.string().oneOf(["false", "true"]).required(PRINT_OFFER_MSG),
    collectiveInvoiceType: Yup.string().oneOf(["individual", "collective"]).required(COLLECTIVE_INVOICE_TYPE_MSG),
    shippingMethodName: Yup.string().oneOf(["1", "2", "3", "4", "5", "6", "7", "8"]).required(SHIPPING_METHOD_NAME_MSG),
    branchId: Yup.string().max(3, BRANCH_ID_MSG),
    orderText: ORDER_TEXT_REQUIRED
      ? Yup.string().max(20, ORDER_TEXT_MSG).required(ORDER_TEXT_REQUIRED_MSG)
      : Yup.string().max(20, ORDER_TEXT_MSG),
    orderNumber: ORDER_TEXT_REQUIRED
      ? Yup.string().max(15, ORDER_NUMBER_MSG).required(ORDER_TEXT_REQUIRED_MSG)
      : Yup.string().max(15, ORDER_NUMBER_MSG),
    validTill: validTillRequired && Yup.string().required(VALID_TILL_REQUIRED_MSG),
    admNumber: Yup.string()
      .matches(/^[0-9]+$/gi, ADM_NUMBER_REQUIRED_MSG)
      .max(3, ADM_NUMBER_MSG)
      .min(3, ADM_NUMBER_MSG)
      .required(ADM_NUMBER_REQUIRED_MSG),
    costUnit: costUnitRequired
      ? Yup.string().max(20, COST_UNIT_MSG).required(COST_UNIT_REQUIRED_MSG)
      : Yup.string().max(20, COST_UNIT_MSG),
    emailSubject: emailSubjectRequired
      ? Yup.string()
          .min(1, EMAIL_SUBJECT_REQUIRED_MSG)
          .max(200, EMAIL_SUBJECT_MSG)
          .matches(/[a-zA-Z0-9]/, EMAIL_SUBJECT_REQUIRED_MSG)
          .required(EMAIL_SUBJECT_REQUIRED_MSG)
      : Yup.string().max(200, EMAIL_SUBJECT_MSG),
  })
}

/**
 * Order delivery fields validation
 *
 * @returns {Yup}
 */
export const orderDeliveryFieldsValidation = ({
  COUNTRY_MIN_MSG = "The minimum length is 2 characters",
  COUNTRY_MAX_MSG = "The minimum length is 2 characters",
  OBJECT_MSG = "The maximum length is 30 characters",
  NAME_MSG = "The maximum length is 30 characters",
  COMPANY_NAME_MSG = "The maximum length is 30 characters",
  STREET_MSG = "The maximum length is 30 characters",
  POSTAL_CODE_MSG = "The maximum length is 5 characters",
  CITY_MSG = "The maximum length is 30 characters",
  ADDITIONAL_LOCATION_MSG = "The maximum length is 30 characters",
  ALTERNATIVE_SA_REQUIRED = false,
  ALTERNATIVE_SA_REQUIRED_TEXT = "This field is required",
} = {}) => {
  return Yup.object({
    country: ALTERNATIVE_SA_REQUIRED
      ? Yup.string().min(2, COUNTRY_MIN_MSG).max(2, COUNTRY_MAX_MSG).required(ALTERNATIVE_SA_REQUIRED_TEXT)
      : Yup.string(),
    object: Yup.string().max(30, OBJECT_MSG),
    name: ALTERNATIVE_SA_REQUIRED
      ? Yup.string().max(30, NAME_MSG).required(ALTERNATIVE_SA_REQUIRED_TEXT)
      : Yup.string().max(30, NAME_MSG),
    companyName: Yup.string().max(30, COMPANY_NAME_MSG),
    street: ALTERNATIVE_SA_REQUIRED
      ? Yup.string().max(30, STREET_MSG).required(ALTERNATIVE_SA_REQUIRED_TEXT)
      : Yup.string().max(30, STREET_MSG),
    postalCode: ALTERNATIVE_SA_REQUIRED
      ? Yup.string().max(5, POSTAL_CODE_MSG).required(ALTERNATIVE_SA_REQUIRED_TEXT)
      : Yup.string().max(5, POSTAL_CODE_MSG),
    city: ALTERNATIVE_SA_REQUIRED
      ? Yup.string().max(30, CITY_MSG).required(ALTERNATIVE_SA_REQUIRED_TEXT)
      : Yup.string().max(30, CITY_MSG),
    additionalLocation: Yup.string().max(30, ADDITIONAL_LOCATION_MSG),
  })
}

/**
 * Validates fields for cash return checkout form
 *
 * @returns {Yup}
 */
export const cashReturnFieldsValidation = ({
  ADM_NUMBER_MSG = "The length has to be 3 characters",
  ADM_NUMBER_REQUIRED_MSG = "This field is required",
} = {}) => {
  return Yup.object({
    admNumber: Yup.string()
      .matches(/^[0-9]+$/gi, ADM_NUMBER_REQUIRED_MSG)
      .max(3, ADM_NUMBER_MSG)
      .min(3, ADM_NUMBER_MSG)
      .required(ADM_NUMBER_REQUIRED_MSG),
  })
}
